import { all, takeEvery } from 'redux-saga/effects';

import services from '../services';
import EntryActionTypes from '../../../constants/EntryActionTypes';

export default function* contentViewPlansWatchers() {
  yield all([
    takeEvery(
      EntryActionTypes.CONTENT_VIEW_PLANS_IN_CURRENT_BOARD_FETCH,
      () => services.fetchContentViewPlansInCurrentBoard(),
    ),
    takeEvery(
      EntryActionTypes.CONTENT_VIEW_PLAN_IN_CURRENT_BOARD_GET_OR_CREATE,
      ({ payload: { year, month } }) => services.getOrCreateContentViewPlanInCurrentBoard(year, month),
    ),
    takeEvery(EntryActionTypes.CONTENT_VIEW_PLAN_UPDATE, ({ payload: { id, data } }) =>
      services.updateContentViewPlan(id, data),
    ),
  ]);
}

